import React, { useContext, useEffect } from "react";
import BryntumContext from "../../context/bryntumContext.jsx";
import { deselectionOnHeaderClick, handleHeaderButtonMenuShowOnHover } from "../../../other/utils/utils.jsx";
import LastUpdateText from "./lastUpdateText/LastUpdateText.jsx";
import AppBoardButton from "./headerButtons/appBoardButton/AppBoardButton.jsx";
import AppViewButton from "@/react/components/appHeader/headerButtons/appViewButton/AppViewButton.jsx";
import AppSelectedViewButton from "./headerButtons/appSelectedViewButton/AppSelectedViewButton.jsx";
import SwivuHeaderControlButtons from "./SwivuHeaderControlButtons.jsx";
import AppSwivuButton from "./headerButtons/appSwivuButton/AppSwivuButton.jsx";
import { EntityNameButton } from "../entityManager/components/EntityNameButton.tsx";

export default function MainHeader() {
  const context = useContext(BryntumContext);
  const { viewManager, entityManager } = context;

  const isEntityManagerView = entityManager.isOpen;

  useEffect(() => {
    if (viewManager) {
      const detacher = deselectionOnHeaderClick(() => {
        if (viewManager?.pageViewsRef) {
          return Object.values(viewManager.pageViewsRef);
        }
      });

      return () => {
        detacher();
      };
    }
  }, [viewManager]);

  useEffect(() => {
    return handleHeaderButtonMenuShowOnHover();
  }, [isEntityManagerView]);

  return (
    <>
      <div className="flex md:justify-start justify-center items-center gap-3 lg:gap-5">
        <AppSwivuButton />
        <AppBoardButton />
        <AppViewButton />
        {!isEntityManagerView ? <AppSelectedViewButton /> : <EntityNameButton />}
      </div>
      <div className="flex items-center justify-end gap-5">
        <LastUpdateText />
        <SwivuHeaderControlButtons />
      </div>
    </>
  );
}
